<template lang="pug">
el-dialog(
    :visible="visible",
    :title="title",
    width="400px",
    top="20vh",
    :close-on-click-modal="false",
    :close-on-press-escape="false",
    @close="onDeny"
)
    p.mb-3(style='word-break: keep-all;') {{ message }}
    .d-flex.justify-content-end
        BaseButton(size='mini', @click='onDeny') {{ denyText }}
        BaseButton(size='mini', type='primary', @click='onConfirm') {{ confirmText }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'GenericConfirmModal',
    components: { BaseButton },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: 'Confirmação'
        },
        message: {
            type: String,
            default: 'Essa alteração irá sobreescrever as informações, deseja confirmar?'
        },
        confirmText: {
            type: String,
            default: 'Confirmar'
        },
        denyText: {
            type: String,
            default: 'Negar'
        }
    },
    methods: {
        onConfirm() {
            this.$emit('confirm');
        },
        onDeny() {
            this.$emit('deny');
        }
    }
};
</script>

<style scoped lang="scss">
.mb-3 {
    margin-bottom: 1rem;
}
</style>
